
















































declare const componentHandler: any;
import API from '@aws-amplify/api';
import Auth from '@aws-amplify/auth';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { State, Mutation } from 'vuex-class';
import ListDecorator from '../components/ListDecorator.vue';
import Message from '../class/Message';
import Attachment from '../class/Attachment';
import Mixin from '../mixin';

@Component({
  components: { ListDecorator },
})
export default class MessageDetail extends Mixin {
  @Prop() private groupid!: string;
  @Prop() private msgid!: string;
  @State('message') private messages!: any;
  @Mutation private updateMessage!: (m: Message) => void;
  private sortAsc: boolean = false;
  private sortProp: string = '';
  private message: Message = new Message();

  private async created() {
    try {
      if (navigator.onLine) {
        this.message = await API.get('api', `/message/get?oid=${this.groupid}&id=${this.msgid}`, {
          headers: {Authorization: (await Auth.currentSession() as any).idToken.jwtToken },
        });
        this.sortAsc = true;
        this.sort('Read');
        this.updateMessage(this.message);
      } else {
        this.message = this.messages[this.groupid].filter((m: Message) => m.ID === this.msgid)[0];
      }
    } catch (ex) {
      this.msg(ex);
    }
  }

  private get mobileUser() {
     return this.message.Read ? this.message.Read.filter((u) => u.UserID !== '') : [];
  }

  private get mobileUserReadCount() {
    return this.mobileUser.filter((u) => u.Read).length;
  }

  private get mailUser() {
    return this.message.Read ? this.message.Read.filter((u) => u.UserID === '') : [];
  }


  private showImage(event: any, v: Attachment) {
    const viewer = this.$el.querySelector('#viewer') as HTMLElement;
    viewer.style.display = 'block';
    (viewer.firstChild as Element).innerHTML = v.Name;
    (viewer.lastChild as HTMLImageElement).src = v.Path;
  }

  private hide(event: any) {
    event.currentTarget.style.display = 'none';
  }

  private async reload(func: (f: () => void) => void) {
    func(async () => {
      try {
        this.message = await API.get('api', `/message/get?oid=${this.groupid}&id=${this.msgid}`, {
          headers: {Authorization: (await Auth.currentSession() as any).idToken.jwtToken },
        });
      } catch (ex) {
        this.msg(ex);
      }
      this.sortAsc = !this.sortAsc;
      this.sort(this.sortProp);
      componentHandler.upgradeDom();
    });
  }

  private async republish() {
    const targetId = Array.from(this.$el.querySelectorAll('td:first-of-type .mdl-checkbox.is-checked'))
      .map((v: any, i: any, self: any[]) => {
        const p = v.parentElement.parentElement as any;
        return p.id;
      });
    if (targetId.length === 0) {
      this.msg('送信先を選択してください');
      return;
    }
    const target = this.message.Read.filter((s: any) => targetId.indexOf(s.UserID) > -1);
    const body = { OrganizationID: this.groupid, MessageID: this.msgid, UserID: target };
    try {
      await API.post('api', '/message/republish', {
        headers: {Authorization: (await Auth.currentSession() as any).idToken.jwtToken },
        body,
      });
      this.msg('通知を再送しました');
    } catch (ex) {
      if (ex.response && ex.response.status === 403) {
        this.msg('再送までの時間が短すぎるか、再送の上限回数に達しています');
      } else {
        this.msg(ex);
      }
    }
    return;
  }

  private sort(prop: string) {
    this.sortProp = prop;
    this.sortAsc = !this.sortAsc;
    this.message.Read.sort((m1: any, m2: any) => {
      return (this.sortAsc ? m1[prop] < m2[prop] : m2[prop] < m1[prop]) ? -1 : 1;
    });
    componentHandler.upgradeDom();
  }

}
